module.exports = __webpack_public_path__ + "static/media/kitchens.a887e70b.png";